import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import "../style/DashboardLayout.css";

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(prev => !prev);
  };

  const toggleMobileSidebar = () => {
    setMobileOpen(prev => !prev);
  };

  const closeMobileSidebar = () => {
    setMobileOpen(false);
  };

  // Handle Escape key to close mobile sidebar
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && mobileOpen) {
        closeMobileSidebar();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [mobileOpen]);

  // Close mobile sidebar when window resizes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && mobileOpen) {
        setMobileOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [mobileOpen]);

  return (
    <div className="app-container" style={{ overflow: 'hidden', width: '100vw', height: '100vh' }}>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div 
          className="sidebar-overlay active" 
          onClick={closeMobileSidebar}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              closeMobileSidebar();
            }
          }}
          aria-label="Close sidebar"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 899,
            opacity: 1,
            pointerEvents: 'auto'
          }}
        />
      )}
      
      <Sidebar 
        collapsed={collapsed} 
        onToggle={toggleSidebar}
        mobileOpen={mobileOpen}
        onMobileToggle={toggleMobileSidebar}
      />
      
      <div 
        className={`main ${collapsed ? "collapsed" : ""}`}
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: collapsed ? '72px' : '240px',
          width: `calc(100vw - ${collapsed ? '72px' : '240px'})`,
          maxWidth: `calc(100vw - ${collapsed ? '72px' : '240px'})`,
          overflow: 'hidden',
          transition: 'margin-left 0.3s ease, width 0.3s ease',
          position: 'relative',
          zIndex: 1
        }}
      >
        <div 
          className="header"
          style={{
            height: '70px',
            flexShrink: 0,
            overflow: 'visible',
            position: 'relative',
            zIndex: 100
          }}
        >
          <Header 
            onMobileToggle={toggleMobileSidebar}
            mobileOpen={mobileOpen}
          />
        </div>
        
        {/* 🔥 ROUTES RENDER HERE */}
        <div 
          className="content"
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: 0,
            background: '#f5f7fb',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
